(() => {
  const init = () => {
    document.querySelectorAll('[data-rs-purchases]').forEach((root) => {
      if (root.dataset.rsInitialized === 'true') return;
      root.dataset.rsInitialized = 'true';

      const library = root.querySelector('[data-rs-library]');
      const libraryHeader = root.querySelector('[data-rs-library-header]');
      const detailHost = root.querySelector('[data-rs-detail-host]');
      const cards = [...root.querySelectorAll('[data-rs-purchase-card]')];
      const search = root.querySelector('[data-rs-purchase-search]');
      const noResults = root.querySelector('[data-rs-no-results]');
      const countSource = root.querySelector('[data-rs-purchase-count-source]');
      const countLabel = root.querySelector('[data-rs-purchase-count]');

      if (countSource && countLabel) {
        const count = Number(countSource.textContent.trim()) || 0;
        countLabel.textContent = `${count} purchase${count === 1 ? '' : 's'}`;
      }

      const setUrl = (handle = '') => {
        const url = new URL(window.location.href);
        if (handle) url.searchParams.set('purchase', handle);
        else url.searchParams.delete('purchase');
        window.history.pushState({ purchase: handle }, '', url);
      };

      const showLibrary = ({ updateUrl = true } = {}) => {
        if (!library || !detailHost) return;
        detailHost.hidden = true;
        detailHost.innerHTML = '';
        library.hidden = false;
        if (libraryHeader) libraryHeader.hidden = false;
        if (updateUrl) setUrl('');
        window.scrollTo({ top: Math.max(root.offsetTop - 24, 0), behavior: 'smooth' });
      };

      const showDetail = (handle, { updateUrl = true } = {}) => {
        if (!handle || !library || !detailHost) return false;
        const template = root.querySelector(`template[data-rs-detail-template="${CSS.escape(handle)}"]`);
        if (!template) return false;

        detailHost.innerHTML = '';
        detailHost.appendChild(template.content.cloneNode(true));
        library.hidden = true;
        if (libraryHeader) libraryHeader.hidden = true;
        detailHost.hidden = false;
        if (updateUrl) setUrl(handle);
        window.scrollTo({ top: Math.max(root.offsetTop - 24, 0), behavior: 'smooth' });
        return true;
      };

      root.addEventListener('click', (event) => {
        const viewButton = event.target.closest('[data-rs-view-purchase]');
        if (viewButton) {
          event.preventDefault();
          showDetail(viewButton.dataset.purchaseHandle);
          return;
        }

        if (event.target.closest('[data-rs-back-to-purchases]')) {
          event.preventDefault();
          showLibrary();
        }
      });

      window.addEventListener('popstate', () => {
        const handle = new URL(window.location.href).searchParams.get('purchase');
        if (handle && showDetail(handle, { updateUrl: false })) return;
        showLibrary({ updateUrl: false });
      });

      if (search) {
        search.addEventListener('input', () => {
          const query = search.value.trim().toLowerCase();
          let visible = 0;
          cards.forEach((card) => {
            const match = !query || (card.dataset.title || '').includes(query);
            card.hidden = !match;
            if (match) visible += 1;
          });
          if (noResults) noResults.hidden = visible !== 0 || cards.length === 0;
        });
      }

      const modal = root.querySelector('[data-rs-report-modal]');
      const reportProduct = root.querySelector('[data-rs-report-product]');
      const reportSource = root.querySelector('[data-rs-report-source]');
      const reportUrl = root.querySelector('[data-rs-report-url]');
      const reportOrder = root.querySelector('[data-rs-report-order]');
      const reportSummary = root.querySelector('[data-rs-report-summary]');

      const closeModal = () => {
        if (!modal) return;
        modal.hidden = true;
        document.documentElement.classList.remove('rs-modal-open');
      };

      const openModal = (button) => {
        if (!modal) return;
        if (reportProduct) reportProduct.value = button.dataset.product || '';
        if (reportSource) reportSource.value = button.dataset.source || '';
        if (reportUrl) reportUrl.value = button.dataset.sourceUrl || '';
        if (reportOrder) reportOrder.value = button.dataset.order || '';
        if (reportSummary) reportSummary.textContent = `${button.dataset.product || 'Purchase'} — ${button.dataset.source || 'Product source'}`;
        modal.hidden = false;
        document.documentElement.classList.add('rs-modal-open');
        setTimeout(() => modal.querySelector('select, textarea, button')?.focus(), 20);
      };

      root.addEventListener('click', (event) => {
        const reportButton = event.target.closest('[data-rs-report-open]');
        if (reportButton) {
          event.preventDefault();
          openModal(reportButton);
          return;
        }
        if (event.target.closest('[data-rs-report-close]')) {
          event.preventDefault();
          closeModal();
        }
        if (event.target.closest('[data-rs-toast-close]')) {
          event.target.closest('.rs-toast')?.remove();
          return;
        }

        const copyButton = event.target.closest('[data-rs-copy-url]');
        if (copyButton) {
          event.preventDefault();
          const url = copyButton.dataset.url || '';
          if (!url) return;

          const originalText = copyButton.textContent;
          const showCopied = () => {
            copyButton.textContent = 'COPIED ✓';
            copyButton.classList.add('is-copied');
            window.setTimeout(() => {
              copyButton.textContent = originalText;
              copyButton.classList.remove('is-copied');
            }, 1600);
          };

          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url).then(showCopied).catch(() => {
              const textarea = document.createElement('textarea');
              textarea.value = url;
              textarea.setAttribute('readonly', '');
              textarea.style.position = 'fixed';
              textarea.style.opacity = '0';
              document.body.appendChild(textarea);
              textarea.select();
              document.execCommand('copy');
              textarea.remove();
              showCopied();
            });
          } else {
            const textarea = document.createElement('textarea');
            textarea.value = url;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            textarea.remove();
            showCopied();
          }
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
      });

      const initialHandle = new URL(window.location.href).searchParams.get('purchase');
      if (initialHandle) {
        showDetail(initialHandle, { updateUrl: false });
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
